/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Case_Debts_Save_ErrorInputs */

const en_case_debts_save_error = /** @type {(inputs: Case_Debts_Save_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not save the debts: ${i?.message}`)
};

const pt_br2_case_debts_save_error = /** @type {(inputs: Case_Debts_Save_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Não foi possível salvar os débitos: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Could not save the debts: {message}" |
*
* @param {Case_Debts_Save_ErrorInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_debts_save_error = /** @type {((inputs: Case_Debts_Save_ErrorInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Debts_Save_ErrorInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_debts_save_error(inputs)
	return pt_br2_case_debts_save_error(inputs)
});